import update from 'immutability-helper';
import {
  ON_API_ERROR,
  AUTH_LOGOUT,
} from '../actions/types';

import {createReducer} from '../utils';

const initialState = {
  error: null,
};
const errorReducer = createReducer(initialState, {
  [ON_API_ERROR]: (state, payload) => {
    const {error, header} = payload;
    return update(state, {
      error: {$set: error},
      header: {$set: header},
    });
  },
  '@@router/LOCATION_CHANGE': state => update(state, {error: {$set: null}}),
  [AUTH_LOGOUT]: () => initialState,
});

export default errorReducer;
